import React from 'react';

type Props = {
    id      :  ID
    title   :  string
    close   :  callback
    fadeTime: number
}

export default function ReminderCreated(props: Props) {

    const openEvent = () => {
        gd.goTo('reminder/'+props.id);
        props.close();
    };

    const classes = Classes("notification", "create")

    return (
        <div className={classes} style={{transition: "opacity " + props.fadeTime + "s"}}>
            <div className="flex-row-left-top">
                <div className="left-indicator">
                    <div className="i5-done ui5-color-green fs-15 create-icon"/>
                </div>

                <div className="right-content">
                    <div className="ui5-txt-not-important-small m-b-8">Reminder created</div>
                    <div className="ui5-txt-less-important-small txt-truncate max-w-225 m-b-8">{props.title}</div>
                    <div className="flex-row-between-center">
                        <div className="flex-row-left-center">
                            <div className="flex-row-left-center link" onClick={openEvent}>
                                <div className="i5-open-new-window m-r-5"></div>
                                <div className="ui5-txt-link-tiny">Open</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )
}
